import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ContextService } from '@apply4u/services/context-service';
import { Navigation } from '@apply4u/shared/constant/navigation/navigation';
import { BrowseJobs_By_Location_RouteUrl } from '@apply4u/shared/constant/navigation/navigation';

@Component({
  selector: 'looking-for-work-items',
  templateUrl: './looking-for-work-items.component.html',
  standalone:true,
  imports:[NgIf,RouterLink,RouterLinkActive]
})
export class LookingForWorkItemsComponent implements OnInit {
  Navigations = Navigation;
  BrowseJobsByLocation = BrowseJobs_By_Location_RouteUrl;

  constructor(public ContextService: ContextService) {
  }

  ngOnInit() {
  }
}
